// Kwalificeringsvragen staan alleen op het eerste meetmoment. Dat is geen regel
// op de invulpaden: de vragen staan in `ExcludedFieldIDs` van alle andere
// meetmomenten, zodat `filterFieldsForMoment` ze daar weghaalt (en de lege
// sectiekop meteen ook). Deze functie rekent die lijsten opnieuw uit na elke
// wijziging aan de meetmomenten of aan de schakelaar.
//
// Eigen uitsluitingen van de gebruiker blijven staan, in hun volgorde. Alleen
// de kwalificeringsvragen worden toegevoegd of weggehaald.
// AI-CONTEXT: See docs/features/sector-kwalificeringsvragen.md

import notDeleted from '../notDeleted'
import firstMeasureMoment from './firstMeasureMoment'

/**
 * @typedef {import('./firstMeasureMoment').MeasureMomentDoc} MeasureMomentDoc
 */

/**
 * @typedef {object} ExclusionUpdate
 * @property {string} docid - Firestore-documentnaam van het meetmoment
 * @property {Array<string>} ExcludedFieldIDs - De nieuwe lijst
 */

/**
 * @param {Array<string>} current
 * @param {Array<string>} next
 * @returns {boolean}
 */
const sameSet = (current, next) => (
    current.length === next.length && next.every((id) => current.includes(id))
)

/**
 * @param {Array<MeasureMomentDoc>} moments - De meetmomenten van één onderzoek, ook verwijderde
 * @param {Array<string>} qualifyingFieldIds - `QuestionnaireFields.ID`'s van de kwalificeringsvragen
 * @param {{ active?: boolean }} [options] - `active: false` haalt de vragen overal weg (schakelaar uit)
 * @returns {Array<ExclusionUpdate>} Alleen de meetmomenten waarvan de lijst verandert.
 */
const qualifyingExclusions = (moments, qualifyingFieldIds, { active = true } = {}) => {
    const alive = (Array.isArray(moments) ? moments : []).filter(notDeleted)
    const first = active ? firstMeasureMoment(alive) : null
    const qualifying = new Set(qualifyingFieldIds)

    return alive.flatMap((moment) => {
        const current = Array.isArray(moment.ExcludedFieldIDs) ? moment.ExcludedFieldIDs : []
        const own = current.filter((id) => !qualifying.has(id))
        const asksQuestions = !active || moment === first
        const next = asksQuestions ? own : [...current, ...qualifyingFieldIds.filter((id) => !current.includes(id))]

        return sameSet(current, next) ? [] : [{ docid: moment.docid, ExcludedFieldIDs: next }]
    })
}

export default qualifyingExclusions
